import validator from "validator";

export function validateCitizenCard(number) {
    number = number.split("").reverse().join("").toLowerCase();

    if (number.length === 12) {
        const conv = {
            "0": 0, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9,
            "a": 10, "b": 11, "c": 12, "d": 13, "e": 14, "f": 15, "g": 16, "h": 17, "i": 18, "j": 19,
            "k": 20, "l": 21, "m": 22, "n": 23, "o": 24, "p": 25, "q": 26, "r": 27, "s": 28, "t": 29,
            "u": 30, "v": 31, "w": 32, "x": 33, "y": 34, "z": 35
        };

        let value, sum = 0;
        for (let i = 0; i < number.length; i++) {
            value = conv[number[i]];
            if (i % 2 !== 0) {
                value *= 2;
                if (value > 9) {
                    value -= 9
                }
            }
            sum += value;
        }

        if (sum % 10 !== 0) {
            return false;
        }
    } else {
        return false;
    }
    return true;
}

export function validateIdentityCard(number) {
    if (number.length === 9) {
        const check = parseInt(number[8]);
        number = number.slice(0, 8).split("").reverse();

        let value = 0;
        number.forEach((v, k) => {
            value += (k + 2) * v;
        })

        if (!((value + check) % 11 === 0 || (check === 0 && (value + 10) % 11 === 0))) {
            return false;
        }
    } else {
        return false;
    }
    return true;
}

export function validatePassport(number) {
    if (number.length === 8) {
        if (!validator.isPassportNumber(number.slice(0, 2), number.slice(2,))) {
            return false;
        }
    } else {
        return false;
    }
    return true;
}

export function validateTaxNumberPT(nif) {
    if (nif && nif.length === 9) {
        let added = ((nif[7] * 2) + (nif[6] * 3) + (nif[5] * 4) + (nif[4] * 5) + (nif[3] * 6) + (nif[2] * 7) + (nif[1] * 8) + (nif[0] * 9));
        let mod = added % 11;
        let control;

        if (mod === 0 || mod === 1) {
            control = 0;
        } else {
            control = 11 - mod;
        }
        return parseInt(nif[8]) === control;
    } else {
        return false;
    }
}
